<template>
    <v-card>
      <v-card-title class="dialog-header">
        <span class="headline">{{ $t("product") }}</span>
        <v-spacer></v-spacer>
        <v-btn
          fab
          text
          icon
          @click="handleClose()"
          valid="false"
          v-shortkey="['esc']"
          @shortkey.native="handleClose()"
        >
        <span class="white--text">
          <v-icon dark>
            mdi-close
          </v-icon>
        </span>
        </v-btn>
      
        </v-card-title>
          <v-card-text>
            <v-form v-model="valid" ref="formProduct">
              <v-container fluid>
                <v-row :no-gutters="$vuetify.breakpoint.mobile">
                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-autocomplete
                        v-model="formDoc.product_type"
                        :items="parentCategories"
                        item-name="product_type"
                        item-value="product_type"
                        outlined
                        :dense="dense"
                        :label="$t('productType') + '*'"
                        :rules="selectRules"
                        required
                        clearable
                      >
                    <template v-slot:item="{item}">{{$t(item.product_type)}}</template>
                    <template v-slot:selection="{item}">{{$t(item.product_type)}}</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                      <v-autocomplete
                          v-model="formDoc.category_id"
                          :items="childCategories"
                          item-text="name"
                          item-value="id"
                          outlined
                          :dense="dense"
                          :label="$t('category') + '*'"
                          :rules="selectRules"
                          required
                          clearable
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                              <v-btn
                                  style="margin-top: -7px; min-width: 40px"
                                    @click="handleAddMore('category', $event)"
                                    color="default"
                                >
                                <font-awesome-icon icon="plus-circle"/>
                              </v-btn>
                            </v-slide-x-reverse-transition>
                          </template>
                      </v-autocomplete>

                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                      <v-text-field
                        v-model="formDoc.sku"
                        :label="$t('code') + '*'"
                        :rules="valueRules"
                        required
                        outlined
                        :disabled="+formDoc.id ? true : false"
                        dense
                      ></v-text-field>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-text-field
                        v-model="formDoc.name"
                        :label="$t('name') + '*'"
                        :rules="valueRules"
                        required
                        outlined
                        
                        dense
                      ></v-text-field>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-text-field
                        v-model="formDoc.cost"
                        :label="$t('cost') + '*'"
                        :rules="requireAndNumber"
                        required
                        outlined
                        dense
                        :suffix="formDoc.currency_code"
                      ></v-text-field>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-text-field
                        v-model="formDoc.price"
                        :label="$t('price') + '*'"
                        :rules="requireAndNumber"
                        required
                        outlined
                        dense
                        :suffix="formDoc.currency_code"
                      ></v-text-field>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-autocomplete
                        v-model="formDoc.unit_id"
                        :items="listUnits"
                        item-text="actual_name"
                        item-value="id"
                        :rules="valueRules"
                        required
                        outlined
                        :dense="dense"
                        :label="$t('unit') + '*'"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                            <v-btn
                                style="margin-top: -7px; min-width: 40px"
                                  @click="handleAddMore('unit', $event)"
                                  color="default"
                              >
                              <font-awesome-icon icon="plus-circle"/>
                            </v-btn>
                          </v-slide-x-reverse-transition>
                        </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-text-field
                      outlined
                      dense
                      v-model="formDoc.supplier_name"
                      :label="$t('supplierName')"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4">
                    <v-text-field
                      outlined
                      dense
                      v-model="formDoc.supplier_phone"
                      :label="$t('supplierPhone')"
                      :rules="phoneRulesOptional"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xl="4" lg="4" md="4" v-if="! formDoc.id">
                    <v-text-field
                        v-model="formDoc.opening_qty"
                        :label="$t('opening_qty') + '*'"
                        :rules="requireAndNumber"
                        required
                        outlined
                        
                        dense
                      ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                        v-model="formDoc.product_description"
                        outlined
                        :label="$t('description')"
                        rows="3"
                      ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" outlined text @click="handleClose()">
            {{ $t('close') }}
          </v-btn>
          <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
            <font-awesome-icon icon="check-circle" class="mr-1"/>
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";
import { uploadFile, removeFile } from '../../../helpers';

export default {
  name: "product",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      preview_avatar: '',
      avatar_msg: '',
      old_image: '',

      formDoc: {
        id: "",
        image: "",
        sku: "",
        name: "",
        product_type: "",
        category_id: "",
        unit_id: "",
        opening_qty: '',
        product_description: '',
        product_note: '',
        cost: '',
        price: '',
        contact_id: this.$store.state.userDoc.contact_id,
        eco_business: 'out_side',
        currency_code: 'KHR',
        supplier_name: '',
        supplier_phone:''
      },

    };
  },

  created() {
    if(this.$store.state.outsideBusiness.dialog && this.$store.state.outsideBusiness.dialog_type == 'product'){
      this.fetchParentCategory();
      this.fetchTransactionUnit({search: '', limit: this.noLimit, offset: this.currentPage});
    }
  },

  methods: {
    reset() {
      let vm = this;
      if (vm.$refs.formProduct) {
          vm.$refs.formProduct.resetValidation();
          vm.formDoc.id           = "";
          vm.formDoc.image        = "";
          vm.formDoc.sku          = "";
          vm.formDoc.name         = "";
          vm.formDoc.product_type = "";
          vm.formDoc.category_id  = "";
          vm.formDoc.unit_id      = "";
          vm.formDoc.opening_qty  = "";
          vm.formDoc.product_description  = "";
          vm.formDoc.product_note  = "";
          vm.formDoc.cost          = "",
          vm.formDoc.price         = "",
          vm.preview_avatar        = "";
          vm.avatar_msg            = "";
          vm.supplier_name         = "";
          vm.supplier_phone        = "";
      }
    },

    handleClose(){
        this.$store.dispatch('updateOutsideBusinessDialog', {dialog: false, dialog_type: 'product'})
        this.$store.dispatch('updateOutsideBusinessProductTmp', {});
    },

     async handleAddMore(type){
      await this.$store.dispatch('updateOutsideBusinessProductTmp', this.formDoc);
      await this.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: type})
    },

    submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formProduct.validate()) {
          vm.overlay = true;

          let url = provider.baseURL + provider.storeProductRegistration;

          return new Promise((resolve, reject) => {
              axios.post(url, this.formDoc, {headers: {Authorization: localStorage.token
                }}).then(
                  res => {
                    if (res.data.response && res.data.response.code === 200) {
                      this.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'image'});
                      this.$store.dispatch('updateOutsideBusinessProductId', res.data.data.product_id);
                    }
                  },
                  error => {
                      reject(error);
                  }
              );
          });
      }
    },

    upload_avatar(event) {
       /**
         * splite extension to check validation
         */
        var json_img        = event.target.files[0];
        var split           = json_img.type.split("/");

        if (split[0] == "image") {

          var reader        = new FileReader();
          var img           = new Image();

          reader.onload     = e => {
            /**
             * declear varable of scope
             */
            var vm            = this;
            vm.preview_avatar = e.target.result;
            
             /**
             * Dimention of image with * height
             */
            img.onload        = function() { vm.avatar_msg = ""; };
            img.src           = reader.result;
          };

          reader.readAsDataURL(json_img);
          event.target.value = '';

          /**upload to firebase */
          let that = this;
          let uploadTask = uploadFile(json_img);
            uploadTask.on('state_changed', function(){
            }, function() { //*note upploadTask multiple work wait untile complete
            }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                  if(that.old_image){
                    removeFile(that.old_image);
                  }
                  that.old_image = downloadURL;
                  that.formDoc.image = downloadURL;
                });
            });
        }
        else {
          this.formDoc.image   = "";
          this.preview_avatar = "";
          this.avatar_msg     = "Allow only png, jpeg, jpg, gif.";
        }
    },

    removeFileUpload(url){
      if(url){
        removeFile(url);
        this.preview_avatar = "";
        this.formDoc.image  = "";
        this.old_image      = "";
      }
    },
  },

  computed:{
    productItem(){
      return this.$store.state.outsideBusiness.products;
    }

  },
  watch: {
    productItem(item){
      if(Object.keys(item).length){
        let vm = this;
        vm.formDoc.id                 = item.id; 
        // vm.formDoc.image              = item.image;
        vm.formDoc.sku                = item.sku;
        vm.formDoc.name               = item.name;
        vm.formDoc.price              = item.price;
        vm.formDoc.cost               = item.cost;
        vm.formDoc.product_type       = item.product_type_key;
        vm.formDoc.category_id        = item.category_id;
        vm.formDoc.unit_id            = item.unit_id;
        vm.formDoc.product_description= item.product_description;
        // vm.preview_avatar             = item.image;
        vm.formDoc.supplier_name      = item.supplier_name;
        vm.formDoc.supplier_phone     = item.supplier_phone;
      }else{
        let tmp = this.$store.state.outsideBusiness.product_tmp;
        if(Object.keys(tmp).length){
            let vm = this;
            vm.formDoc.id             = tmp.id; 
            // vm.formDoc.image          = tmp.image;
            vm.formDoc.sku            = tmp.sku;
            vm.formDoc.name           = tmp.name;
            vm.formDoc.price          = tmp.price;
            vm.formDoc.cost           = tmp.cost;
            vm.formDoc.product_type   = tmp.product_type;
            vm.formDoc.category_id    = tmp.category_id;
            vm.formDoc.opening_qty    = tmp.opening_qty;
            vm.formDoc.unit_id        = tmp.unit_id;
            vm.formDoc.product_description  = tmp.product_description;
            // vm.preview_avatar         = tmp.image;
            vm.formDoc.supplier_name  = tmp.supplier_name;
            vm.formDoc.supplier_phone = tmp.supplier_phone;
        }else{
          this.reset();
          
        }
      }
    },

    "formDoc.category_id"(val){
      if(val){
        this.fetchGrandChildCategory({productType: this.formDoc.product_type, parent_id: val})
      }
    },

    "formDoc.product_type"(val){
      if(val){
        this.fetchChildCategory({productType: val})
      }
    },
  }
  
};
</script>